import { useEffect, useState } from "react";

export function UnlockDirectorDialog({
  sceneLabel,
  consumedWarning,
  onCancel,
  onConfirm,
}: {
  sceneLabel: string;
  /** Shown when the previous submission was already inserted into program manus. */
  consumedWarning?: string | null;
  onCancel: () => void;
  onConfirm: (options: { archive: boolean; label?: string }) => void;
}) {
  const [archive, setArchive] = useState(true);
  const [label, setLabel] = useState("");

  useEffect(() => {
    function onKey(e: KeyboardEvent) {
      if (e.key === "Escape") onCancel();
    }
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onCancel]);

  return (
    <div className="sm-dialog-backdrop" role="presentation" onClick={onCancel}>
      <div
        className="sm-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="sm-unlock-director-title"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 id="sm-unlock-director-title">Lås scene op</h2>
        {consumedWarning ? (
          <p className="sm-dialog-warn" role="status">
            {consumedWarning}
          </p>
        ) : (
          <p>
            Du er ved at låse {sceneLabel} op. Efter oplåsning redigerer du den
            afleverede version (inkl. noter), og ændringerne gemmes direkte under
            Afleverede scener.
          </p>
        )}
        <label className="sm-setting">
          <input
            type="checkbox"
            checked={archive}
            onChange={(e) => setArchive(e.target.checked)}
          />
          <span>Arkivér en kopi af scenen, som den ser ud nu</span>
        </label>
        {archive ? (
          <label className="sm-dialog-field sm-archive-label-field">
            <span className="sm-archive-label-heading">
              Navn på arkivkopien
              <span className="sm-dialog-hint-inline"> (valgfrit)</span>
            </span>
            <input
              type="text"
              value={label}
              onChange={(e) => setLabel(e.target.value)}
              placeholder="fx Før oplåsning"
              autoFocus
              maxLength={120}
            />
          </label>
        ) : null}
        <div className="sm-dialog-actions">
          <button type="button" onClick={onCancel}>
            Annuller
          </button>
          <button
            type="button"
            className="sm-dialog-primary"
            onClick={() =>
              onConfirm({
                archive,
                label: label.trim() || undefined,
              })
            }
          >
            Lås op
          </button>
        </div>
      </div>
    </div>
  );
}
